/**
 * Fetch with AbortController timeout (CRM-019: 6–8s for CRM-related calls).
 *
 * @param {string|URL} url - Request URL
 * @param {RequestInit} [options] - fetch options (signal is replaced by a combined timeout)
 * @param {number} [timeoutMs=8000] - Milliseconds before abort
 * @returns {Promise<Response>}
 */
export async function fetchWithTimeout(url, options = {}, timeoutMs = 8000) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    return await fetch(url, {
      ...options,
      signal: controller.signal,
    });
  } catch (err) {
    if (err?.name === 'AbortError') {
      const timeoutError = new Error('Request timed out');
      timeoutError.name = 'TimeoutError';

      throw timeoutError;
    }

    throw err;
  } finally {
    clearTimeout(timeoutId);
  }
}
